import { render, staticRenderFns } from "./Destinatarios.vue?vue&type=template&id=46c47176&scoped=true"
import script from "./Destinatarios.vue?vue&type=script&lang=js"
export * from "./Destinatarios.vue?vue&type=script&lang=js"
import style0 from "./Destinatarios.vue?vue&type=style&index=0&id=46c47176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c47176",
  null
  
)

export default component.exports